export default value => (value ? 'active' : 'inactive');
